import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-mvvm';
import { makeObservable, observable } from 'mobx';

@ViewModel()
export class MicrofrontendViewModel implements IReactiveModel {
  @observable isLoading = true;
  @observable error: any;

  constructor() {
    makeObservable(this);
  }

  onInit() {
    // Execute before component initialize
    this.isLoading = false;
  }

  onDestroy() {
    // Execute before component destroy
  }
}
